import type { ReactNode } from "react";
import { clsx } from "../../utils/clsx";
import * as styles from "./Card.css";

type CardProps = {
  title?: string;
  children: ReactNode;
  strong?: boolean;
};

export function Card({ title, children, strong = false }: CardProps) {
  return (
    <article className={clsx(styles.card, strong && styles.strong)}>
      {title ? <h3 className={styles.title}>{title}</h3> : null}
      <div className={styles.text}>{children}</div>
    </article>
  );
}
